/**
 * Types that we expect from the PHP backend
 */

/**
 * Sometimes the PHP backend will forward Businessmap errors.
 * For example, if an error occurs on checking the access data.
 */
export type BsmapError = {
	error: {
		code: string;
		message: string;
		reference: string;
		details: Record<string, string>
	}
}

/**
 * We will need to know if the response is an error.
 */
export const isBsmapError = (elem:any): elem is BsmapError => {
	if (typeof elem != 'object' || !Object.keys(elem).includes('error')) return false;

	const errorElems = Object.keys(elem.error);
	if (!errorElems.includes('code')) return false;
	if (!errorElems.includes('message')) return false;
	if (!errorElems.includes('reference')) return false;
	if (!errorElems.includes('details')) return false;

	return true;
};

export type CheckAccessResponse = {
	code: '200';
	data: {
		apikey: string;
	};
};

export type GetBoardStructureResponse = {
	code: '200';
	data: {
		workflow_id: number;
		name: string;
		lanes: {
			lane_id: number;
			name: string;
		}[];
		columns: {
			column_id: number;
			name:string;
		}[]
	}[]
};

export type AddAttachmentsResponse = {
	code: '200';
	data: 'OK';
};

export type UsersResponse = {
	code: '200';
	data: {
		user_id: number;
		username: string;
	}[]
}

export type BoardsResponse = {
	code:'200';
	data: {
		board_id: number;
		name: string
	}[]
}

export type CreateCardResponse = {
	code: '200';
	data: number; // The id of the created card.
};

export type CreateCommentResponse = {
	code: '200';
	data: number; // The id of the created comment.
};